/**
 * useEnvironmentalLayers Hook
 *
 * @version 3.0
 * @updated 2026-03-26
 * @module core/modules/environmental/hooks
 *
 * @description
 * Hook para gestionar capas REALES del módulo Environmental.
 * Carga árboles desde la API del proyecto activo.
 *
 * FASE B: Corrección de visibilidad - Reemplaza datos mock por datos reales.
 */

import { useEffect } from 'react';
import { SampleDataService } from '../services/sample-data.service';
import { useEnvironmentalMapLayers } from './useEnvironmentalMapLayers';
import { useProject } from '../../../projects';
import { useModuleStore } from '../../../module-store';

/**
 * Hook para gestionar capas del módulo Environmental
 *
 * @remarks
 * Carga datos REALES de árboles cuando:
 * - El proyecto está activo
 * - El módulo environmental o urban-network está activo (árboles son parte del contexto urbano)
 */
export function useEnvironmentalLayers(): void {
  const { projectId } = useProject();
  const { activeModule } = useModuleStore();

  // Determinar si mostrar capas environmental
  const visible = Boolean(
    projectId &&
      (activeModule === 'environmental' ||
        activeModule === 'urban-network' ||
        activeModule === 'waste') // waste también puede ver árboles para contexto
  );

  // Limpiar capas mock al inicio
  useEffect(() => {
    SampleDataService.removeAllLayers();

    return (): void => {
      SampleDataService.removeAllLayers();
    };
  }, []);

  // Cargar capas reales
  useEnvironmentalMapLayers({
    projectId: projectId || '',
    visible,
  });
}
